import Button from "olive-react-myoneui/lib/Button";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RedirectURLObject from "../RedirectURLObject";
import { useTranslation } from "react-i18next";
import { commonModuleName } from "../../constants/config";


function EnrollNowButton({ className = "", variant = "secondary", itemType = 'course', itemId = '' }) {
  const { t } = useTranslation(commonModuleName);
  const navigate = useNavigate();
  const redirectObjectURL = RedirectURLObject({ type: 'enroll_now', redirectTo: `/bulk_learners_enroll/${itemId}/${itemType}` });
  const button_index = ["booking_event"].includes(itemType) ? "event_free_button" : "free_button";
  const miscellaneous = useSelector(state => state.user.miscellaneous);
  const enrollButtonClick = () => {
    redirectObjectURL.isReact ? navigate(redirectObjectURL.url) : window.location.href = redirectObjectURL.url;
  }
  return (
    miscellaneous[button_index + "_enabled"] &&
    <Button
      variant={variant}
      className={className}
      size="md"
      onClick={enrollButtonClick}
    >
      {t(miscellaneous[button_index])}
    </Button>
  );
}

export default EnrollNowButton;
